<template>
  <div class="product">
    <div class="description" v-html="item.description"></div>

    <button class="small-button" @click="productModalShown = true">Info</button>

    <div class="price-container" :style="{ minHeight: showDiscount ? '5.4em' : 'auto' }">
      <div class="base-price" :class="{ 'strikethrough': showDiscount && hasFirstBagDiscount }">
        ${{ itemPrice }}
      </div>
      <div v-if="showDiscount && showSingleSalePrice" class="discount-info">
        <div class="discount-row">
          <span class="discount-label">Sale Price:</span>
          <span class="discount-price">${{ firstDiscountedPrice }}</span>
        </div>
      </div>
      <div v-else-if="showDiscount && (hasFirstBagDiscount || hasAdditionalBagDiscount)" class="discount-info">
        <div v-if="hasFirstBagDiscount">
          <div class="discount-row">
            <span class="discount-label">First Bag:</span>
            <span class="discount-price">${{ firstDiscountedPrice }}</span>
          </div>
        </div>
        <div v-if="hasAdditionalBagDiscount">
          <div class="discount-row">
            <span class="discount-label">Each Extra Bag:</span>
            <span class="discount-price">${{ additionalDiscountedPrice }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <hr style="width: 66%; border: none; border-top: 1px solid #2c8a3d; margin: 1em auto;">
    <quantity ref="quantityStepper" :initialQty="qtyInCart" @changeQuantity="changeQuantity" />
    <button v-if="!inCart" class="flat-green-btn" @click="addItem">Add to Cart</button>
    <button v-else class="flat-red-btn" @click="removeItem">Remove</button>

    <div class="notification-wrapper" :class="[{ show: productModalShown }]" @click.self="closeModal">
      <div class="notification">
        <div class="close-notify" @click="closeModal">
          <i class="fa fa-times"></i>
        </div>
        <div class="notification-content" v-html="item.popup"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Quantity from '../../components/quantity.vue';

export default {
  data() {
    return {
      productModalShown: false,
    };
  },

  props: {
    item: Object,
    qtyInCart: {
      type: Number,
      default: 0,
    },
    showDiscount: {
      type: Boolean,
      default: true,
    },
  },

  created() {
    // Close modal on esc
    document.addEventListener('keyup', (event) => {
      if (event.keyCode === 27) { this.closeModal(); }
    });
  },

  computed: {
    inCart() {
      return this.qtyInCart > 0;
    },

    hasFirstBagDiscount() {
      return this.item.discount_first > 0;
    },

    hasAdditionalBagDiscount() {
      return this.item.discount_additional > 0;
    },

    itemPrice() {
      return accounting.format(this.item.base_price, { precision: 2 });
    },

    firstDiscountedPrice() {
      return accounting.format(this.item.base_price - this.item.discount_first, { precision: 2 });
    },

    additionalDiscountedPrice() {
      return accounting.format(this.item.base_price - this.item.discount_additional, { precision: 2 });
    },

    showSingleSalePrice() {
      return (
        this.item.discount_first === this.item.discount_additional
        && this.item.discount_first > 0
      );
    },
  },

  methods: {
    addItem() {
      const currentItem = {
        ...this.item,
        quantity: this.qtyInCart + 1,
      };
      this.$emit('addItem', currentItem);
    },

    removeItem() {
      this.$emit('removeFromCart', this.item);
    },

    changeQuantity(quantity) {
      if (quantity > 0) {
        this.$emit('addItem', { ...this.item, quantity });
      } else {
        this.$emit('removeFromCart', this.item);
      }
    },

    closeModal() {
      this.productModalShown = false;
    },
  },

  components: {
    Quantity,
  },

};
</script>
<style>
.product {
  width: 100%;
}

.product .description h1 {
  font-size: 1.62em;
}

.description,
.description > * {
  width: inherit !important;
}

.notification {
  max-height: 83vh;
  max-width: 320px;
}

.notification-content {
  overflow: auto;
  justify-content: flex-start !important;
  padding: 1.62em;
  -webkit-overflow-scrolling: touch;
}

.price-container {
  margin: 0.5em 0;
}

.base-price {
  font-weight: bold;
  font-size: 1.6em;
  margin-top: 10px;
}

.strikethrough {
  text-decoration: line-through;
  color: #666;
  font-size: 1.4em;
}

.discount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.discount-info {
  font-size: 1.2em;
  color: #2c8a3d;
  margin-top: 0.25em;
}

.discount-label {
  flex-grow: 1;
  text-align: left;
}

.discount-price {
  font-weight: bold;
  font-size: 1.3em;
  text-align: right;
}
</style>
